// Single source of truth for the third-party session-replay privacy classes.
// See src/App/App.helpers.ts for the Datadog global default that covers form
// fields automatically.

export const PRIVACY_FIELD_CLASS = 'fs-mask';

export const PRIVACY_DISPLAY_CLASSES = 'fs-mask dd-privacy-mask';
